/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Decks_View_Entry_FinalsInputs */



/**
* | output |
* | --- |
* | "{name} (finals)" |
*
* @param {Decks_View_Entry_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_view_entry_finals = /** @type {((inputs: Decks_View_Entry_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_View_Entry_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} (finale)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} (final)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} (final)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} (finale)`)
	return /** @type {LocalizedString} */ (`${i?.name} (finals)`)
});